export interface AppPlugin {
  readonly isApp: boolean
  navigate(url: string): void
}

export default defineNuxtPlugin((nuxtApp) => {
  const layoutCookie = useCookie('ovatu.layout')

  const plugin: AppPlugin = {
    get isApp() {
      return layoutCookie.value === 'app'
    },
    navigate(url: string) {
      if (!import.meta.client) return

      window.OvatuApp?.postMessage(JSON.stringify({
        type: 'navigate',
        url,
      }))
    },
  }

  nuxtApp.provide('app', plugin)
})
